import React, { forwardRef } from 'react';
import { useRefresh } from 'react-admin';

import DialogoEditarVenda from '../../Components/DialogoEditarVenda';

const Container = forwardRef((props, ref) => {
  const refresh = useRefresh();
  function handleClose() {
    refresh();
  }
  return (
    <DialogoEditarVenda ref={ref} handleClose={handleClose} sessionId={0} />
  );
});

export default Container;
